<template>
  <section class="app-documents">
    <v-container>
      <services-list :data="services"></services-list>
    </v-container>
  </section>
</template>

<script>
import { services } from "@/models/service";
import ServicesList from "@/components/ServicesList";
import veiculoService from "@/services/sit-pedidos/veiculo.service";

export default {
  metaInfo: {
    title: "Transportes - Central de Serviços",
  },
  components: {
    ServicesList,
  },
  data: () => {
    return {
      services: [services[0]],
      checkTypeService: false,
    };
  },
  mounted() {
    this.getTipoServico();
  },
  methods: {
    getTipoServico() {
      const { id } = this.transportadora;
      veiculoService.getTipoServicoTransportadora(id).subscribe(
        (res) => {
          this.checkTypeService = res.some(
            (ts) => ts.descricao == "Fretamento"
          );
        },
        (err) => {
          this.checkTypeService = false;
          console.error("Erro ao buscar tipo de serviço:", err);
        }
      );
    },
  },
};
</script>

<style></style>
